/**
 * Footer global — affiche en bas de chaque page (sauf login / public / verify).
 *
 * Volontairement minimal : marque Gaz Systèmes, liens utiles (aide, status,
 * docs), build version. Style aligne sur le design system (sombre, mono,
 * amber).
 */

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink-700 bg-ink-950 mt-16">
      <div className="max-w-[1600px] mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-2xs font-mono">
          {/* Brand */}
          <div className="flex items-center gap-2.5">
            <div className="w-1.5 h-1.5 bg-brand-500" aria-hidden />
            <span className="uppercase tracking-widest text-steel-300">
              GS Copilot
            </span>
            <span className="text-steel-700">·</span>
            <span className="text-steel-500">Gaz Systèmes © {year}</span>
          </div>

          <nav className="flex items-center gap-4 flex-wrap" aria-label="Footer">
            <a
              href="/public/status"
              className="text-steel-500 hover:text-amber-500 transition-colors uppercase tracking-widest"
            >
              Status
            </a>
            <a
              href="mailto:contact@gazsystemes.example"
              className="text-steel-500 hover:text-amber-500 transition-colors uppercase tracking-widest"
            >
              Contact
            </a>
            <span className="text-steel-700 uppercase tracking-widest">
              v
              {(import.meta.env.VITE_RELEASE ?? 'dev').slice(0, 8)}
            </span>
          </nav>
        </div>
      </div>
    </footer>
  );
}
